<template>
  
  <v-container grid-list-xl fluid>

    <v-dialog
      v-model="inventoryDialog"
      max-width="800"
      scrollable
    >
      <v-card color="white">
        
        <v-card-title class="primary white--text text-xs-center" style="position: relative;">
          <v-btn
            absolute
            small
            fab
            top
            right
            flat
            color="white"
            style="top: 10px;"
            @click="inventoryDialog = false"
          ><v-icon>fas fa-times</v-icon></v-btn>
          <h3 style="margin: 0 auto;">Edit Item</h3>
        </v-card-title>
        <v-card-text>
          <v-window
            v-model="inventoryEditingWindow"
          >
            <v-window-item :key="'inventory-lookup'">
           
              <v-layout row style="min-height: 150px;">
                <v-flex xs6>
                  <div class="field-label">Supplier</div>
                  <v-select
                    v-model="inventoryEditing.supplier_id"
                    :items="suppliers"
                    item-text="supplier_name"
                    item-value="_id"
                    hide-details 
                    solo 
                    class="pt-0"
                    flat
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <div class="field-label">Supplier Item ID</div>
                  <v-text-field
                    v-model="inventoryEditing.item_id"
                    hide-details
                    solo
                    class="pt-0"
                    flat
                  ></v-text-field>
                </v-flex>
              </v-layout>

            </v-window-item>
            <v-window-item :key="'inventory-editing'">
            
              <v-layout row>
                <v-flex sm3>
                  <img :src="inventoryEditing.photo" style="max-width: 100%;" />
                </v-flex>
                <v-flex sm9>
                  <v-container fluid grid-list-md ma-0 pa-0>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div class="field-label">Supplier</div>
                        <v-select
                          v-model="inventoryEditing.supplier_id"
                          :items="suppliers"
                          item-text="supplier_name"
                          item-value="_id"
                          hide-details 
                          solo 
                          class="pt-0"
                          flat
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <div class="field-label">Supplier Item ID</div>
                        <v-text-field
                          v-model="inventoryEditing.item_id"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <div class="field-label">Supplier Alternate Item ID</div>
                        <v-text-field
                          v-model="inventoryEditing.alt_item_id"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="field-label">Photo URL</div>
                        <v-text-field
                          v-model="inventoryEditing.photo"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="field-label">Name</div>
                        <v-text-field
                          v-model="inventoryEditing.item_name"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Category</div>
                        <v-text-field
                          v-model="inventoryEditing.item_category"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Fabric</div>
                        <v-text-field
                          v-model="inventoryEditing.item_fabric"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Color</div>
                        <v-text-field
                          v-model="inventoryEditing.item_color"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Brand</div>
                        <v-text-field
                          v-model="inventoryEditing.item_brand"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Size</div>
                        <v-text-field
                          v-model="inventoryEditing.item_size"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Retail Price</div>
                        <v-text-field
                          v-model="inventoryEditing.item_retail_price"
                          type="number"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">TrvlPorter Price</div>
                        <v-text-field
                          v-model="inventoryEditing.item_tp_price"
                          type="number"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <div class="field-label mt-2">Purchase Price</div>
                        <v-text-field
                          v-model="inventoryEditing.item_tp_purchase_price"
                          type="number"
                          hide-details
                          solo
                          class="pt-0"
                          flat
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <div class="field-label mt-2">Description</div>
                        <v-textarea
                          v-model="inventoryEditing.item_desc"
                          autoGrow
                          hide-details
                          solo 
                          class="pt-0" 
                          rows="2"
                          flat
                        >
                        </v-textarea> 
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            
            </v-window-item>
          </v-window>
        </v-card-text>
        <v-card-actions class="primary white--text">
          <v-spacer></v-spacer>
          <v-btn v-if="inventoryEditingWindow == 0" color="primary white--text" @click="lookupInventoryByItemId()" :loading="inventoryLookingUp">
            LOOKUP
          </v-btn>
          <v-btn v-else color="primary white--text" @click="saveInventory()" :loading="inventorySaving">
            SAVE
          </v-btn>
          <v-btn v-if="inventoryEditingWindow == 1 && inventoryEditing._id" color="primary white--text" @click="cloneInventory()">Clone</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-right">
        <v-text-field
          v-model="search"
          label="Search"
          style="max-width: 500px; display: inline-block;"
        >
        </v-text-field>
        <v-tooltip top>
          <v-btn slot="activator" small color="primary" style="min-width: 0px; font-size: 12px;" :disabled="search == null || search == ''"><v-icon>fas fa-search</v-icon></v-btn>
          <span>Search</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" small color="primary" style="min-width: 0px; font-size: 12px;" @click="openInventory('new')"><v-icon>fas fa-plus</v-icon></v-btn>
          <span>Add New</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="inventory"
          :pagination.sync="pagination"
          :total-items="totalInventory"
          :loading="loading"
          :rows-per-page-items="[25]"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr @click="openInventory(props.item._id)" style="cursor: pointer;">
              <td><img :src="props.item.photo" style="max-width: 50px;" /></td>
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_category }}</td>
              <td>{{ props.item.item_size }}</td>
              <td>{{ props.item.item_color }}</td>
              <td>{{ props.item.item_brand }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>

export default {
  name: 'AdminInventory',
  data () {
    return {
      loading: true,
      search: null,
      inventory: [],
      inventoryDialog: false,
      inventoryEditing: {},
      inventoryEditingWindow: 1,
      inventoryLookingUp: false,
      inventorySaving: false,
      suppliers: [],

      headers: [
        {
          text: '',
          sortable: false,
        },
        {
          text: 'Name',
          sortable: false,
          value: 'item_name'
        },
        {
          text: 'Category',
          sortable: false,
          value: 'item_category'
        },
        {
          text: 'Size',
          sortable: false,
          value: 'item_size'
        },
        {
          text: 'Color',
          sortable: false,
          value: 'item_color'
        },
        {
          text: 'Brand',
          sortable: false,
          value: 'item_brand'
        }
      ],
      pagination: {},
      totalInventory: 0,
    }
  },
  mounted: function() {
    this.getSuppliers();
    this.getDataFromApi();
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi();
      },
      deep: true
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
  },
  methods: {
    getSuppliers: function() {
      this.$http.get('suppliers')
        .then(supplierResponse => {
          this.suppliers = supplierResponse.data.data;
        })
        .catch(supplierError => {
          this.$swal.fire('Error', 'There was an error loading supplier data');
        });
    },
    getDataFromApi: function() {
      this.loading = true
        
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      
      this.$http.get('inventories?limit=' + rowsPerPage + '&page=' + page) 
        .then(response => {
          this.totalInventory = response.data.items.total;
          this.inventory = response.data.data;
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error loading inventory');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openInventory: function(id) {
      this.inventorySaving = false;
      if(!id || id == 'new') {
        this.inventoryEditing = {
          supplier_id: (this.suppliers.length ? this.suppliers[0]._id : null)
        };
        this.inventoryEditingWindow = 0;
      } else {
        for(let i = 0; i < this.inventory.length; i++) {
          if(this.inventory[i]._id == id) this.inventoryEditing = JSON.parse(JSON.stringify(this.inventory[i]));
        }
        this.inventoryEditingWindow = 1;
      }
      this.inventoryDialog = true;
    },
    lookupInventoryByItemId: function(id) {
      this.inventoryLookingUp = true;

      this.$http.get('inventories?item_id=' + this.inventoryEditing.item_id)
        .then(response => {
          for(let i = 0; i < response.data.data.length; i++) {
            if(response.data.data[i].supplier_id == this.inventoryEditing.supplier_id) this.inventoryEditing = response.data.data[i];
          }
          this.inventoryEditingWindow = 1;
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error looking up the inventory item');
        })
        .finally( () => {
          this.inventoryLookingUp = false;
        });
    },
    saveInventory: function() {
      let data = {};
      if(!this.inventoryEditing.supplier_id) {
        this.$swal.fire('Supplier Required', 'You must select a supplier');
        return;
      }
      if(!this.inventoryEditing.item_id) {
        this.$swal.fire('Supplier Item ID Required', 'You must enter a supplier item id');
        return;
      }

      let ignore_keys = [
        '_id',
        'archived',
        'create_date',
        'last_update'
      ];
      for(let i = 0; i < Object.keys(this.inventoryEditing).length; i++) {
        let key = Object.keys(this.inventoryEditing)[i];
        if(key == 'item_retail_price' || key == 'item_tp_price' || key == 'item_tp_purchase_price') {
          data[key] = (!this.inventoryEditing[key] ? 0 : this.inventoryEditing[key]);
        } else if(ignore_keys.indexOf(key) < 0) {
          if(this.inventoryEditing[key] != null && this.inventoryEditing[key] != "") {
            data[key] = this.inventoryEditing[key];
          }
        }
      }

      this.inventorySaving = true;
      if(!this.inventoryEditing._id) {
        //New
        this.$http.post('inventories', data)
          .then(invResponse => {
            this.inventory.unshift( invResponse.data );
            this.inventoryDialog = false;
          })
          .catch(invError => {
            this.$swal.fire('Error', 'There was an error creating this inventory item');
          }).finally(()=>{ this.inventorySaving = false; });
      } else {
        //Update
        this.$http.patch('inventories/' + this.inventoryEditing._id, data)
          .then(invResponse => {
            let found = false;
            for(let i = 0; i < this.inventory.length; i++) {
              if(this.inventory[i]._id == invResponse.data._id) {
                found = true;
                this.$set(this.inventory, i, invResponse.data);
                break;
              }
            }
            if(!found) this.inventory.push( invResponse.data );
            this.inventoryDialog = false;
          })
          .catch(invError => {
            this.$swal.fire('Error', 'There was an error creating this inventory item');
          }).finally(()=>{ this.inventorySaving = false; });
      }
    },

    cloneInventory: function() {
      if(!this.inventoryEditing._id) return;

      this.$set(this.inventoryEditing, '_id', null);
      this.$set(this.inventoryEditing, 'item_id', null);
      this.$set(this.inventoryEditing, 'alt_item_id', null);
      this.$set(this.inventoryEditing, 'item_size', null);

      this.$toast.fire('Clone Prepared. Set new item ids and sizes');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
